export const DEV_URL = 'https://api.dullabam.com/';
export const CARD_URL = 'https://api.dullabam.com/';

export default DEV_URL;
